import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-8 mb-10 flex flex-col" }
const _hoisted_2 = { class: "text-2xl text-light4 -mb-2 uppercase font-black truncate" }
const _hoisted_3 = { class: "text-6xl leading-tight font-black" }
const _hoisted_4 = { class: "text-4xl" }

import { computed, onMounted } from "vue";
import { useProfileStore } from "@/store/Profile";
import { useScheduleStore } from "@/store/Schedule";
import loggingService from "@/services/LoggingService";
import { formatTime } from "@/helpers/Time";
import i18n from "@/locale";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const profileStore = useProfileStore();
const scheduleStore = useScheduleStore();

onMounted(() => {
  loggingService.info("Unavailable.vue", "🟦 Unavailable view mounted");
});

const { t } = useI18n();

const dateOptions: Intl.DateTimeFormatOptions = { month: "long", day: "numeric" };

const availability = computed(() => {
  const nextStart = profileStore.nextAvailableTime(scheduleStore.getTime);
  if (nextStart) {
    const nextStartD = new Intl.DateTimeFormat(i18n.global.locale, dateOptions).format(nextStart);
    const nextStartP = formatTime(nextStart, profileStore.tabletTimeFormat);
    return t("untilDate", { nextStartD, nextStartP });
  }
  return t("untilFurtherNotice");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-col",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeUpcoming')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("resourceName", { resourceName: _unref(profileStore).resourceName })), 1),
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("unavailableNow")), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(availability)), 1)
    ])
  ]))
}
}

})